module.exports = __webpack_public_path__ + "img/corriente_a_blue.7649ce1f.svg";